import React, { useState } from "react";
import { auth } from "./firebase";
import { Link, useNavigate } from "react-router-dom";
import {
  setPersistence,
  browserSessionPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      await setPersistence(auth, browserSessionPersistence);
      await signInWithEmailAndPassword(auth, email, password);
      console.log("Login successful");
      navigate("/cybersecurity/course-overview");
    } catch (err) {
      console.error("Login error:", err);
      if (
        err.code === "auth/user-not-found" ||
        err.code === "auth/wrong-password"
      ) {
        setError(
          "Ungültige E-Mail oder Passwort. Bitte überprüfen Sie Ihre Eingaben."
        );
      } else {
        setError(
          "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="col-md-6">
        <div className="text-center mb-4">
          <img
            src="/images/zebbs_Logo.svg"
            class="d-block mx-auto mb-4"
            alt=""
            style={{ width: "50%" }}
          />
        </div>

        <p className="text-center mb-4">
          Willkommen zu einem der faszinierendsten und zugleich
          herausforderndsten Themen unserer digitalen Ära - der Cybersecurity.
          <br /> Ob du deine beruflichen Fähigkeiten erweitern möchtest oder
          einfache nur über bestimmte Themen mehr erfahren möchtest - wir freuen
          uns, dich auf deiner Lernreise begleiten zu dürfen.
        </p>

        <div className="text-center mb-4">
          <img src="/images/1.webp" alt="Logo" style={{ width: "150px" }} />
          <h2 className="text-center m-5">Login</h2>
        </div>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>E-Mail</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group mt-3">
            <label>Passwort</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="text-danger mt-3">{error}</p>}
          <button
            type="submit"
            className="btn btn-primary btn-block mt-4"
            disabled={isLoading}
          >
            {isLoading ? "Anmeldung..." : "Login"}
          </button>
        </form>
        <div className="text-center mt-3">
          <Link to="/cybersecurity/forgot-password">Passwort vergessen?</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
